export default __webpack_public_path__ + "static/media/insurance.9d7802ad.pdf";